import React, { useContext, useState } from 'react';
import proptypes from 'prop-types';
const { node, number, bool, string, object, shape } = proptypes;
import { Link } from '@one-thd/sui-atomic-components';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';

const CheckNearByStore = (props) => {
  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const {
    itemId,
    quantity,
    originalConfigId,
    lineItemId,
    children,
    isShipToHomeEligible,
    addOnsAssemblyAndMore,
    isCartTiles,
    storeIdFromCart,
    leadTime,
    hasCustomATC,
    storeNameLink,
    isMyStore,
    enableCheckNearbyStoreView,
    isBopisAvailable,
    giftCardPromotion
  } = props;
  let host = 'https://www.homedepot.com';
  if (typeof window !== 'undefined') {
    host = window.location.origin.match(/local/g)
      ? 'https://www.homedepot.com'
      : window.location.origin;
  }

  const { storeId } = useStore();

  const cartAnalytics = {
    enableCheckNearbyStoreView,
    isBopisAvailable
  };

  const cartReqParams = {
    itemId,
    host,
    quantity,
    keyword: isCartTiles ? storeIdFromCart : storeId,
    channel,
    isShipToHomeEligible,
    alterBrowserHistory: true,
    addOnsAssemblyAndMore,
    leadTime,
    hasCustomATC,
    promotionId: giftCardPromotion?.promotionId || '',
    experienceTag: giftCardPromotion?.experienceTag || '',
    reward: giftCardPromotion?.reward ? encodeURIComponent(JSON.stringify(giftCardPromotion.reward)) : ''
  };

  if (lineItemId) {
    cartReqParams.lineItemId = lineItemId;
  }
  if (originalConfigId) {
    cartReqParams.paintConfiguration = { configurationId: originalConfigId };
  }
  function triggerSelectStore(event) {
    if (enableCheckNearbyStoreView && isMyStore && !isConsumerApp) {
      document.dispatchEvent(new Event('launchLocDrawer'));
      // To track when the my-store drawer is opened
      window?.LIFE_CYCLE_EVENT_BUS?.trigger('localization.my-store', { cartAnalytics });
    } else {
      event.stopPropagation();
      event.preventDefault();
      // To track when the check-nearby-stores drawer is opened
      window?.LIFE_CYCLE_EVENT_BUS?.trigger('cart.select-store', {
        cartAnalytics,
        cartReqParams
      });
    }
  }

  return storeNameLink ? (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      // eslint-disable-next-line react/jsx-no-bind
      onClick={triggerSelectStore}
      data-testid={isMyStore ? 'pickup-store-link' : 'check-nearby-stores-link'}
      className="sui-flex sui-inline-flex sui-underline"
    >
      {children}
    </Link>
  ) : (
    <span className="sui-flex sui-inline-flex" data-testid="check-nearby-stores-span">
      {children}
    </span>
  );
};

CheckNearByStore.propTypes = {
  itemId: string.isRequired,
  children: node.isRequired,
  isShipToHomeEligible: bool,
  // eslint-disable-next-line react/forbid-prop-types
  addOnsAssemblyAndMore: object,
  isCartTiles: bool,
  storeIdFromCart: string,
  lineItemId: string,
  quantity: number,
  leadTime: number,
  hasCustomATC: bool,
  originalConfigId: string,
  storeNameLink: bool,
  isMyStore: bool,
  enableCheckNearbyStoreView: bool,
  isBopisAvailable: bool,
  giftCardPromotion: shape({
    promotionId: string,
    experienceTag: string,
    // eslint-disable-next-line react/forbid-prop-types
    reward: proptypes.array
  }),
};

CheckNearByStore.defaultProps = {
  isShipToHomeEligible: false,
  addOnsAssemblyAndMore: null,
  storeIdFromCart: '',
  isCartTiles: false,
  lineItemId: '',
  quantity: 1,
  leadTime: 0,
  hasCustomATC: false,
  originalConfigId: null,
  storeNameLink: true,
  isMyStore: false,
  enableCheckNearbyStoreView: false,
  isBopisAvailable: false,
  giftCardPromotion: null,
};

export { CheckNearByStore };
